import React from "react";

function Spinner() {
  return (
    <div
      style={{
        width: 24,
        height: 24,
        border: "3px solid var(--color-primary)",
        borderTop: "3px solid transparent",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
      }}
    >
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default Spinner;
